/*
 * AddClass Messages
 *
 * This contains all the text for the AddClass component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'app.components.AddGroup.title',
        defaultMessage: 'Enter the name of the new group'
    },
    inputPlaceholder: {
        id: 'app.components.AddGroup.inputPlaceholder',
        defaultMessage: 'Enter the name of the new group'
    },
    done: {
        id: 'app.components.AddGroup.done',
        defaultMessage: 'Done'
    },
    manageStudent: {
        id: 'app.components.AddGroup.manageStudent',
        defaultMessage: 'Manage student'
    },
    changeCourse: {
        id: 'app.components.AddGroup.changeCourse',
        defaultMessage: 'Change course'
    },
    createdAssigned: {
        id: 'app.components.AddGroup.createdAssigned',
        defaultMessage: ' created and assigned to '
    },
    maxGroupErrorTitle: {
        id: 'app.components.AddGroup.maxGroupErrorTitle',
        defaultMessage: 'This group cannot be created.'
    },
    maxGroupErrorLongDesc: {
        id: 'app.components.AddGroup.maxGroupErrorLongDesc',
        defaultMessage: 'You are allowed with a maximum of 12 groups per class, please delete a group to proceed.'
    },
    okBtn: {
        id: 'app.components.AddGroup.okBtn',
        defaultMessage: 'Ok'
    }
});



// WEBPACK FOOTER //
// ./app/components/add-group/messages.js